<template>

    <v-modal title="Create Sender">
        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Sender Type">
                <v-select :model="type" @input="type = $event">
                    <option value="">Select Sender Type</option>
                    <option value="custom">Custom Sender (@yourdomain.com)</option>
                    <option value="smtp">SMTP Sender (@anydomain.com)</option>
                </v-select>
            </v-form-group>
            <v-notice v-if="type === 'custom' && !domain" size="sm" type="danger" message="Add a sending domain to add a custom sender." />
            <v-notice v-else-if="type === 'smtp' && !project.smtp_config.host" size="sm" type="danger" message="Configure SMTP sending to add an SMTP sender." />
            <form v-else-if="type" @keydown.enter.prevent="createSender">
                <v-form-group dir="ver" label="Name">
                    <v-input :model="params.name" @input="params.name = $event" />
                </v-form-group>
                <v-form-group v-if="type === 'smtp'" dir="ver" label="Email Address">
                    <v-input-group placeholder="notifications@mycompany.com" :model="params.email" @input="params.email = $event" />
                </v-form-group>
                <v-form-group v-else-if="type === 'custom'" dir="ver" label="Email Address">
                    <v-input-group :input-group-append="`@${domain.name_root}`" :model="params.from" @input="params.from = $event" />
                </v-form-group>
                <v-form-group dir="ver">
                    <v-checkbox label="Default Sender" :model="params.is_default" @input="params.is_default = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createSender">Create Sender</v-button>
        </template>
    </v-modal>

</template>

<script>

import SenderApi from '@api/SenderApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
            type: 'custom',
            params: {},
        }
    },

    computed: {

        company() {
            return this.$store.getters.company;
        },

        domain() {
            return this.$store.getters.project.domain;
        },

    },

    methods: {

        createSender() {
            this.loading = true;
            this.params.type = this.type;
            this.params.project_id = this.project.id;
            if (this.type === 'custom') {
                this.params.domain_id = this.domain ? this.domain.id : null;
            }
            SenderApi.createSender(this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('created');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
